import { TableColumnMeta } from "ds/components/Table/types";

import { FilterItemKeys } from "../../constants";

export const SPACES_LIST_COLUMNS_STORAGE_KEY = "spacesListTableColumnsConfig";

// px form of the `--table-head-height` CSS token (the sticky-head offset)
export const STICKY_TOP_BASE_PX = 44;

// Rows the pinned ancestor stack has to leave visible below itself. A stack allowed to reach the
// viewport bottom hides the whole subtree it belongs to, so pinning turns off before that.
export const STICKY_STACK_MIN_VISIBLE_ROWS = 3;

export enum SPACES_LIST_COLUMN_ID {
  NAME = "NAME",
  CHILDREN = "CHILDREN",
  LABELS = "LABELS",
  INHERIT_ENTITIES = "INHERIT_ENTITIES",
  ID = "ID",
  ROW_ACTIONS = "ROW_ACTIONS",
}

const MAX_CELL_WIDTH = 2000;

const INHERIT_ENTITIES_TOOLTIP =
  "Space inheritance is a tool for sharing resources between spaces. When a space inherits " +
  "from another space, it can access all the resources in the parent space.";

export const SPACES_LIST_COLUMN_CONFIG: Record<SPACES_LIST_COLUMN_ID, TableColumnMeta> = {
  [SPACES_LIST_COLUMN_ID.NAME]: {
    id: SPACES_LIST_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 250,
    defaultWidth: 500,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
    // The tree indentation and the expand toggles live in the first column, so this one stays there
    anchored: true,
  },
  [SPACES_LIST_COLUMN_ID.CHILDREN]: {
    id: SPACES_LIST_COLUMN_ID.CHILDREN,
    title: "Children",
    minWidth: 110,
    defaultWidth: 110,
    maxWidth: 200,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: false,
    canMove: true,
  },
  [SPACES_LIST_COLUMN_ID.LABELS]: {
    id: SPACES_LIST_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: false,
    canMove: true,
  },
  [SPACES_LIST_COLUMN_ID.INHERIT_ENTITIES]: {
    id: SPACES_LIST_COLUMN_ID.INHERIT_ENTITIES,
    title: "Inherit",
    tooltip: INHERIT_ENTITIES_TOOLTIP,
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: 300,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: false,
    canMove: true,
  },
  [SPACES_LIST_COLUMN_ID.ID]: {
    id: SPACES_LIST_COLUMN_ID.ID,
    title: "ID",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: false,
    canMove: true,
  },
  [SPACES_LIST_COLUMN_ID.ROW_ACTIONS]: {
    id: SPACES_LIST_COLUMN_ID.ROW_ACTIONS,
    title: "Space actions",
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    noHeader: true,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const SPACES_LIST_SORT_CONFIG: Record<string, string> = {
  [SPACES_LIST_COLUMN_ID.NAME]: FilterItemKeys.NAME,
  [SPACES_LIST_COLUMN_ID.CHILDREN]: FilterItemKeys.CHILDREN,
  [SPACES_LIST_COLUMN_ID.ID]: FilterItemKeys.ID,
  [SPACES_LIST_COLUMN_ID.INHERIT_ENTITIES]: FilterItemKeys.INHERIT_ENTITIES,
};
